<form form="ngForm">
    <select [(ngModel)]="relacao" id="relacao" name="relacao" class="form-control" (change)="onChange()" appShowErrorMessages [required]="required">
    <option value="1">1 - Amigo</option>
    <option value="2">2 - Parente</option>
    <option value="3">3 - Vizinho</option>
    <option value="4">4 - Outros</option>
  </select>
</form>